/**
 * Shared CI provider detection.
 *
 * Single source of truth for both the CI and Git metadata collectors so they
 * can never disagree on which provider a run belongs to. Order matches
 * testdino-cli so the same run maps to the same provider regardless of which
 * CLI produced it.
 */

/**
 * Detect the CI provider from environment variables, or `undefined` when not
 * running under a recognized provider (i.e. a local run).
 */
export function detectCIProvider(): string | undefined {
  const { env } = process;

  if (env.GITHUB_ACTIONS === 'true') return 'github-actions';
  if (env.GITLAB_CI === 'true') return 'gitlab-ci';
  if (env.JENKINS_URL) return 'jenkins';
  if (env.TF_BUILD === 'True' || env.AZURE_HTTP_USER_AGENT) return 'azure-devops';
  if (env.CIRCLECI === 'true') return 'circleci';
  if (env.CODEBUILD_BUILD_ID) return 'aws-codebuild';
  if (env.BITBUCKET_BUILD_NUMBER) return 'bitbucket-pipelines';
  if (env.BUILDKITE === 'true') return 'buildkite';
  if (env.HARNESS_BUILD_ID || env.HARNESS_PIPELINE_ID) return 'harness';
  if (env.TEAMCITY_VERSION) return 'teamcity';

  return undefined;
}
